// Pure helper, deliberately kept free of JSX/React imports so it can be exercised directly
// with plain Node (`node -e "require('./buildMailto').buildMailtoUrl(...)"`) as well as from
// form.jsx. Builds the mailto: URL the contact form's Submit button opens - see
// task-10-report.md for why the form composes an email instead of posting anywhere: the
// existing form had no Action wired to its submit button and no public endpoint exists to
// send it to.
//
// Every field goes through encodeURIComponent, including the ones concatenated into `body`
// - an unescaped newline or `&` in the message would otherwise truncate the mailto body at
// that character (the URL parser reads up to the first unescaped `&`/newline as the end of
// the `body` param).
const buildMailtoUrl = ({ firstName, lastName, email, message }, to = 'info@nvisiondental.com') => {
    const subject = `Website enquiry from ${firstName} ${lastName}`;
    const body = `Name: ${firstName} ${lastName}\nEmail: ${email}\n\n${message}`;
    return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

module.exports = { buildMailtoUrl };
